import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { select, Store } from '@ngrx/store';
import * as fromPhotos from '@app/my-zone/pages/claims/store/actions/photos.actions';
import { PhotoInterface } from '@app/core/interfaces/photo.interface';
import * as fromRoot from '@app/store/app.reducer';
import * as fromMyClaims from '@app/my-zone/pages/claims/store';

@Component({
    selector: 'ins-photos-container',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <ins-photo
            [loaded]="loaded$ | async"
            [photos]="photos$ | async">
        </ins-photo>
    `
})
export class PhotoContainer implements OnInit, OnDestroy {
    @Input() file_serial_number: number;

    readonly photos$: Observable<PhotoInterface[]> = this.store.pipe(select(fromMyClaims.getSelectedPhotoCollection));
    readonly loaded$: Observable<Boolean> = this.store.pipe(select(fromMyClaims.isPhotosLoaded));

    private subscriptions = new Subscription();

    constructor(
        private store: Store<fromRoot.State>
    ) {}

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    ngOnInit(): void {
        const loadedSubscription = this.loaded$.subscribe(loaded => {
            if (loaded === undefined) {
                this.store.dispatch(new fromPhotos.Load({
                    dossier_volgnummer: this.file_serial_number
                }));
            }
        });

        this.subscriptions.add(loadedSubscription);
    }
}
